/**
 * @flow
 * @relayHash 0ee6531acdc0768e7475bebba5022dac
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetEmailInput = {|
  userId: string,
  clientMutationId?: ?string,
|};
export type SetEmailMutationVariables = {|
  input: SetEmailInput
|};
export type SetEmailMutationResponse = {|
  +setEmail: ?{|
    +user: ?{|
      +email: ?string
    |}
  |}
|};
export type SetEmailMutation = {|
  variables: SetEmailMutationVariables,
  response: SetEmailMutationResponse,
|};
*/


/*
mutation SetEmailMutation(
  $input: SetEmailInput!
) {
  setEmail(input: $input) {
    user {
      email
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetEmailInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SetEmailMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setEmail",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SetEmailPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetEmailMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setEmail",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SetEmailPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "SetEmailMutation",
    "id": null,
    "text": "mutation SetEmailMutation(\n  $input: SetEmailInput!\n) {\n  setEmail(input: $input) {\n    user {\n      email\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4134a74bbf3fe2e8c627f5e130c29522';
module.exports = node;
